import styled from "@emotion/styled";
export const ButtonBarRoot = styled.div`
  display: flex;
  align-items: center;
`;
export const ButtonBarLeft = styled.div`
  display: flex;
  flex: ${(props) => props.center ? "1 0 0" : ""};
  justify-content: flex-start;
  align-items: center;
  margin-right: ${(props) => props.center ? "" : "auto"};
`;
export const ButtonBarCenter = styled.div`
  display: flex;
  align-items: center;
`;
export const ButtonBarRight = styled.div`
  display: flex;
  flex: ${(props) => props.center ? "1 0 0" : ""};
  justify-content: flex-end;
  align-items: center;
  margin-left: ${(props) => props.center ? "" : "auto"};
`;
